<template>
  <div class="bridgeDetails">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>订单信息</span>
        <!-- <el-button
          @click="back()"
          class="back_btn"
          type="primary"
          icon="el-icon-back"
          >返回</el-button
        > -->
      </div>
      <div class="text item">
        <div class="text_item">
          <span>订单编号：</span>
          <span>{{ dateDetails.ORMTB607CA14 }}</span>
        </div>
        <div class="text_item2">
          <span>充电开始时间：</span>
          <span>{{ dateDetails.ORMTB607CA02 }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>充电结束时间：</span>
          <span>{{ dateDetails.ORMTB607CA03 }}</span>
        </div>
        <div class="text_item2" v-if="dateDetails.ORMTB607CA10 != 3">
          <span>充电开始SOC：</span>
          <span>{{ dateDetails.ORMTB607CA16 }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item" v-if="dateDetails.ORMTB607CA10 == 3">
          <span>预约充电时间：</span>
          <span>{{ dateDetails.ORMTB607CA18 }}</span>
        </div>
        <div class="text_item" v-if="dateDetails.ORMTB607CA10 != 3">
          <span>充电结束SOC：</span>
          <span>{{ dateDetails.ORMTB607CA13 }}</span>
        </div>
        <div class="text_item2">
          <span>充电时长：</span>
          <span>{{ dateDetails.ORMTB607CA08 }}</span>
        </div>
      </div>

      <div class="text item">
        <div class="text_item">
          <span>充电电量：</span>
          <span>{{ dateDetails.ORMTB607CA07 || 0 }}</span>
        </div>
        <div class="text_item2">
          <span>启动方式：</span>
          <span>{{ dateDetails.ORMTB607CA09 }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>订单金额：</span>
          <span>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</span>
        </div>
        <div class="text_item2">
          <span>实付金额：</span>
          <span>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>电费金额：</span>
          <span>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</span>
        </div>
        <div class="text_item2">
          <span>服务费金额：</span>
          <span>0元</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>结束原因：</span>
          <span>{{ dateDetails.ORMTB607CA04 || '暂无' }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="box-card1">
      <div slot="header" class="clearfix">
        <span>充电桩信息</span>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>充电桩名称：</span>
          <span>{{ dateDetails.ORMTB602CA03 }}</span>
        </div>
        <div class="text_item2">
          <span>充电桩编号：</span>
          <span>{{ dateDetails.ORMTB602CA00 }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="box-card2">
      <div slot="header" class="clearfix">
        <span>车辆信息</span>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>车牌号码：</span>
          <span>{{ dateDetails.ORMTB607CA12 }}</span>
        </div>
        <div class="text_item2">
          <span>车牌VIN：</span>
          <span>{{ dateDetails.ORMTB607CA11 || '暂无' }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateDetails: {},
    }
  },
  mounted() {
    console.log(this.$route.query.id)
    let id = this.$route.query.id
    let url = '/orm/ormtb607/ormtb607Detail?ormtb607Id=' + id
    this.axios.get(url).then(res => {
      if (res.data.code == 200) {
        console.log('电桩详情', res.data.data)
        this.dateDetails = res.data.data.ormtb607
      }
    })
    // this.dateDetails = JSON.parse(this.$route.query.ormtb602id)
  },
  methods: {
    // back() {
    //   this.$router.back()
    // },
  },
}
</script>

<style scoped>
.bridgeDetails {
  width: 100%;
  height: 800px;
  background: #f3f3f3;
}
.text {
  font-size: 14px;
}
.text_item {
  width: 400px;
}
.text_item2 {
  margin-left: 46%;
}

.item {
  margin-bottom: 18px;
  display: flex;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
  font-weight: 600;
}

.box-card {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
  height: 366px;
}
.box-card1 {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
  height: 135px;
}
.box-card2 {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
  height: 135px;
}
.back_btn {
  float: right;
}
::v-deep .name-header {
  background-color: #e6a23c !important; /* 橙色 */
}
</style>
